import React from "react";
import { cn } from "@/lib/utils";
import { SHEET } from "./labelSheet";

// Cor de cada produto na folha (repete a partir do 5º)
export const ITEM_COLORS = [
  "bg-primary text-primary-foreground",
  "bg-brand-pistachio text-brand-dark",
  "bg-terra text-white",
  "bg-brand-dark text-white",
  "bg-secondary text-secondary-foreground",
];

export const itemColor = (itemIndex) => ITEM_COLORS[itemIndex % ITEM_COLORS.length];

/**
 * Miniatura de uma folha (5 × 13). Cada célula mostra o nº do produto, um "×"
 * para posição pulada (já usada) ou fica em branco. Com `onPick`, as células
 * viram botões para escolher a posição inicial da impressão.
 */
function SheetMap({ slots, onPick, selected, className }) {
  return (
    <div
      className={cn("rounded-lg border border-border bg-card p-1.5 shadow-soft", className)}
      style={{ aspectRatio: `${SHEET.pageWidth} / ${SHEET.pageHeight}` }}
    >
      <div
        className="grid h-full gap-[3px]"
        style={{
          gridTemplateColumns: `repeat(${SHEET.columns}, minmax(0, 1fr))`,
          gridTemplateRows: `repeat(${SHEET.rows}, minmax(0, 1fr))`,
        }}
        role={onPick ? "radiogroup" : "img"}
        aria-label={onPick ? "Posição inicial na folha" : "Mapa da folha de etiquetas"}
      >
        {slots.map((slot, index) => {
          const skipped = slot === "skipped";
          const label = slot && !skipped ? slot.label : null;
          const cellClass = cn(
            "flex min-h-0 items-center justify-center rounded-[3px] text-[9px] font-bold leading-none",
            label
              ? itemColor(label.itemIndex)
              : skipped
              ? "bg-muted text-muted-foreground/70"
              : "border border-dashed border-border bg-surface-low",
            selected === index && "ring-2 ring-primary ring-offset-1 ring-offset-card"
          );
          const content = label ? label.itemIndex + 1 : skipped ? "×" : null;

          if (!onPick) {
            return (
              <span key={index} className={cellClass}>
                {content}
              </span>
            );
          }
          return (
            <button
              key={index}
              type="button"
              role="radio"
              aria-checked={selected === index}
              aria-label={`Começar na etiqueta ${index + 1}`}
              onClick={() => onPick(index)}
              className={cn(cellClass, "transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary")}
            >
              {content}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SheetMap;
